import { MATERIAL, MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

const MATERIAL_TO_MATERIAL_MODE = {
  [MATERIAL.PBR]: 'PBR',
  [MATERIAL.BASIC]: 'shaded',
}

/**
 * Inverse of parseTripo3dRetextureDefaultData. Builds an openedModel-shaped
 * payload from the current textureSettings (plus the modelSettings 3D input)
 * so the just-submitted run can be reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTripo3dRetextureDefaultData
 */
export const buildTripo3dRetextureDefaultFromState = (state, id) => {
  const {
    prompt,
    enablePbr,
    material,
    inputImage,
    inputImageUrl,
  } = state.textureSettings || {}
  const { isPrivate } = state.modelSettings || {}
  const materialMode = material != null ? MATERIAL_TO_MATERIAL_MODE[material] : undefined
  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER.TRIPO3D,
    providerModelId: MODEL_ID.TRIPO3D_RETEXTURE_DEFAULT,
    prompt,
    enablePbr,
    private: isPrivate,
    inputAssets,
    providerRunAttributes: {
      ...(materialMode != null && { materialMode }),
    },
  }
}
